import {Component, OnDestroy} from '@angular/core';

import {MenuItem} from 'primeng/api';

import {Project} from '../../../../core/models/project';
import {AuthUser, TokenService} from '../../../../core/auth';
import {Subscription} from 'rxjs';
import {ProjectSidebarService} from '../../../../projectsidebar.service';

@Component({
  selector: 'app-project-sidebar',
  templateUrl: './project-sidebar.component.html'
})
export class ProjectSidebarComponent implements OnDestroy {

  subscription: Subscription;
  projectModel: MenuItem[];
  project: Project;
  authUser: AuthUser = this.token.whoAmI();

  constructor(
    projectSidebarService: ProjectSidebarService,
    private token: TokenService
  ) {
    this.subscription = projectSidebarService.itemsHandler.subscribe(response => {
      this.project = response;
      if (this.project == null) {
        this.projectModel = [];
      } else {
        this.onProjectExtend();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onProjectExtend() {
    this.projectModel = [

      {label: 'Dashboard', icon: 'fa fa-fw fa-tachometer', routerLink: ['/project', this.project.id, 'overview']},
      {label: 'Players', icon: 'fa fa-fw fa-android', routerLink: ['/project', this.project.id, 'players']},
      {label: 'Telemetry events', icon: 'fa fa-fw fa-rss', routerLink: ['/project', this.project.id, 'telemetry']},
      {
        label: 'Settings', icon: 'fa fa-fw fa-cog',
        items: [
          {
            label: 'Branches',
            icon: 'fa fa-fw fa-code-fork',
            routerLink: ['/project', this.project.id, 'branch', 'list']
          },
          {
            label: 'Project Access',
            visible: this.authUser.hasRole('AC_MANAGE_PROJECT'),
            icon: 'fa fa-fw fa-unlock-alt',
            routerLink: ['/project', this.project.id, 'members']
          },
          {
            label: 'Webhooks',
            visible: this.authUser.hasRole('AC_MANAGE_PROJECT'),
            icon: 'fa fa-fw fa-globe',
            routerLink: ['/project', this.project.id, 'webhooks']
          },
          {
            label: 'Plugin Validation',
            visible: this.authUser.hasRole('AC_MANAGE_CUSTOMER'),
            icon: 'fa fa-fw fa-plug',
            queryParams: {su: true},
            routerLink: ['/project', this.project.id, 'plugins']
          },
        ]
      }
    ];
  }

}
